import React from "react";
import privacyFetchData from "@/data/domain/privacy-page.json";
import { v4 as uuidv4 } from "uuid";
import { PAGE_TITLE } from "@/common/constants/constants";

import styles from "../styles/PrivacyPage.module.scss";

const PrivacyComponent = (): React.JSX.Element => {
  return (
    <div className={styles.wrapper}>
      <h1 className={styles.title}>{PAGE_TITLE.PRIVACY}</h1>
      {privacyFetchData.map((item) => {
        return (
          <div className={styles.content} key={uuidv4()}>
            <div> {item.title}</div> {item.paragraph}
          </div>
        );
      })}
    </div>
  );
};

export default PrivacyComponent;
